import matchPageAlias from '../../../../utils/matchPageAlias';
import mergeObjects from '../../../../utils/mergeObjects';

const resolveProps = (props = {}, isConfirm) => {
	const {
		cksCode,
		confirmOverrides = {},
		default: defaultMapping = {},
		directCall,
		event,
		initOverrides = {},
		page,
		referralPageAlias = []
	} = JSON.parse(JSON.stringify(props)); // clone to avoid mutating properties

	let formProps = {
		...(isConfirm && cksCode && { cksCode }),
		...(directCall && { directCall }),
		...(event && { event }),
		...(page && { page })
	};

	if (Object.keys(defaultMapping).length && referralPageAlias.length) {
		// probably needs a tweak for forms submit via ajax
		const referralProps =
			window?.DDC?.dataLayer?.confirmation?.pageName !== null
				? matchPageAlias(
						window?.DDC?.dataLayer?.confirmation?.pageName,
						referralPageAlias
				  )
				: {};
		formProps = mergeObjects(
			formProps,
			resolveProps(defaultMapping, isConfirm),
			true
		);

		if (Object.keys(referralProps).length) {
			formProps = mergeObjects(
				formProps,
				resolveProps(referralProps, isConfirm),
				true
			);
		}
	} else if (isConfirm) {
		formProps = mergeObjects(formProps, confirmOverrides, true);
	} else {
		formProps = mergeObjects(formProps, initOverrides, true);
	}

	return formProps;
};

/**
 * Gets digitaldata properties for forms by form tracking ID.
 * @param {object} formMapping The whole form mapping for the project
 * @param {string} formTrackingId The form tracking ID
 * @param {boolean} isConfirm Retrieves confirmation props if
 *  true, initation if false
 * @returns {Object} form properties to apply to digitaldata, undefined if not found
 */
export default ({ formMapping, formTrackingId, isConfirm }) => {
	const mapping = formMapping?.[formTrackingId]
		? formMapping?.[formTrackingId]
		: formMapping.default;

	const {
		confirmOverrides,
		default: defaultMapping,
		initOverrides
	} = mapping;

	if (
		(isConfirm && (confirmOverrides || defaultMapping?.confirmOverrides)) ||
		(!isConfirm && (initOverrides || defaultMapping?.initOverrides))
	) {
		return resolveProps(mapping, isConfirm);
	}

	return {};
};
